import { render, staticRenderFns } from "./ClientStats.vue?vue&type=template&id=e4526756&"
import script from "./ClientStats.vue?vue&type=script&lang=js&"
export * from "./ClientStats.vue?vue&type=script&lang=js&"
import style0 from "./ClientStats.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports